
import { isString } from 'lodash';

export class LinkGroup {
  id: string
  name: string
  link_type: string
  link_name: string
  order: number

  constructor(data: any = {}) {
    Object.assign(this, data);
  }

  replaceWith(replacement: LinkGroup) {
    Object.assign(this, replacement);
  }

  get valid(): boolean {
    // name
    if (!isString(this.name)) {
      return false;
    }

    let trimmedName = this.name.trim();

    if (trimmedName.length > 200) {
      return false;
    }

    if (trimmedName.length === 0) {
      return false;
    }

    return true;
  }

  toCreateLinkGroupInput() {
    return {
      name: this.name,
      link_type: this.link_type,
      link_name: this.link_name,
      order: this.order
    };
  }

  toUpdateLinkGroupInput() {
    return {
      name: this.name,
      order: this.order
    };
  }
}
